import {
    Button,
    Card,
    CardContent as MuiCardContent,
    Checkbox,
    FormControl,
    FormControlLabel,
    Grid,
    TextField
} from '@material-ui/core'
import {spacing} from '@material-ui/system'
import {Autocomplete, CircularProgressBar} from 'app/Components'
import {onKeyDown} from "external-lib/utils/helpers";
import {Formik} from 'formik'
import {Dictionaries} from 'lib/dictionaries'
import {isLoading, isProcessing} from 'lib/progress'
import {Source} from 'lib/select'
import {State} from 'lib/store'
import {User} from 'lib/users'
import React from 'react'
import {connect, MapStateToProps} from 'react-redux'
import styled from 'styled-components'
import * as Yup from 'yup'
import {KeyboardDatePicker} from "@material-ui/pickers";
import {format} from "date-fns";

const CardContent = styled(MuiCardContent)(spacing)

type StateToProps = {
    readonly isLoading: boolean
    readonly isProcessing: boolean
}

type FormControlProps = {
    initialValues: User
    handleSubmit: (user: User) => void
}

const Schema = Yup.object().shape({
    login: Yup.string()
        .required('Pole jest wymagane'),
    firstName: Yup.string()
        .required('Pole jest wymagane'),
    lastName: Yup.string()
        .required('Pole jest wymagane'),
    worksSince: Yup.string()
        .required('Pole jest wymagane'),
    email: Yup.string()
        .email('Podaj poprawny adres e-mail')
        .required('Pole jest wymagane'),
    school: Yup.string()
        .required('Pole jest wymagane'),
    roles: Yup.array()
        .nullable()
        .required('Pole jest wymagane'),
})

class FormComponent extends React.Component<FormControlProps & StateToProps> {
    public render = () =>
        <>
            {
                this.props.isLoading
                    ? <CircularProgressBar/>
                    : <Formik
                        initialValues={{...this.props.initialValues, repeatedPassword: ''}}
                        validationSchema={Schema}
                        onSubmit={values => this.props.handleSubmit(values)}
                    >
                        {({
                              values,
                              errors,
                              touched,
                              handleChange,
                              handleBlur,
                              handleSubmit,
                              isSubmitting,
                              setFieldValue
                          }) => (
                            <form onSubmit={handleSubmit} onKeyDown={onKeyDown}>

                                <Card variant="outlined">
                                    <CardContent>

                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <FormControl margin="dense" fullWidth>
                                                    <TextField
                                                        error={Boolean(errors.email && touched.email)}
                                                        label="E-mail *"
                                                        id="email"
                                                        name="email"
                                                        variant="outlined"
                                                        value={values.email}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        helperText={errors.email}
                                                        inputProps={{
                                                            maxLength: 100,
                                                        }}
                                                    />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <FormControl margin="dense" fullWidth>
                                                    <TextField
                                                        error={Boolean(errors.login && touched.login)}
                                                        label="Login *"
                                                        id="login"
                                                        name="login"
                                                        variant="outlined"
                                                        value={values.login}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        helperText={errors.login}
                                                        inputProps={{
                                                            maxLength: 30,
                                                        }}
                                                    />
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <FormControl margin="dense" fullWidth>
                                                    <TextField
                                                        error={Boolean(errors.firstName && touched.firstName)}
                                                        label="Imię *"
                                                        id="firstName"
                                                        name="firstName"
                                                        variant="outlined"
                                                        value={values.firstName}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        helperText={errors.firstName}
                                                        inputProps={{
                                                            maxLength: 100,
                                                        }}
                                                    />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <FormControl margin="dense" fullWidth>
                                                    <TextField
                                                        error={Boolean(errors.lastName && touched.lastName)}
                                                        label="Nazwisko *"
                                                        id="lastName"
                                                        name="lastName"
                                                        variant="outlined"
                                                        value={values.lastName}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        helperText={errors.lastName}
                                                        inputProps={{
                                                            maxLength: 100,
                                                        }}
                                                    />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <FormControl margin="dense" fullWidth>
                                                    <TextField
                                                        error={Boolean(errors.phone && touched.phone)}
                                                        label="Telefon"
                                                        id="phone"
                                                        name="phone"
                                                        variant="outlined"
                                                        value={values.phone}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        helperText={errors.phone}
                                                        inputProps={{
                                                            maxLength: 100,
                                                        }}
                                                    />
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <FormControl margin="dense" fullWidth>
                                                    <KeyboardDatePicker
                                                        error={Boolean(errors.worksSince && touched.worksSince)}
                                                        format="dd-MM-yyyy"
                                                        maxDate={format(new Date(), "dd-MM-yyyy")}
                                                        helperText={errors.worksSince}
                                                        id="birthDate"
                                                        label="Data rozpoczęcia (dd-mm-rrrr)*"
                                                        value={values.worksSince || null}
                                                        onChange={val => {
                                                            setFieldValue("worksSince", val);
                                                        }}
                                                        KeyboardButtonProps={{
                                                            'aria-label': 'zmień datę',
                                                        }}
                                                        autoOk
                                                        cancelLabel="Anuluj"
                                                        inputVariant="outlined"
                                                    />
                                                </FormControl>
                                            </Grid>


                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <FormControl margin="dense" fullWidth>
                                                    <Autocomplete
                                                        label={"Placówka *"}
                                                        field={'school'}
                                                        source={Source.SCHOOLS}
                                                        value={values.school}
                                                        error={Boolean(errors.school && touched.school)}
                                                        setFieldValue={setFieldValue}
                                                        helperText={errors.school as string}
                                                    />
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <FormControl margin="dense" fullWidth>
                                                    <Autocomplete
                                                        label={"Rola *"}
                                                        field={'roles'}
                                                        source={Source.ROLES}
                                                        value={values.roles}
                                                        error={Boolean(errors.roles && touched.roles)}
                                                        multiple={true}
                                                        setFieldValue={setFieldValue}
                                                        helperText={errors.roles as string}
                                                    />
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <FormControl margin="dense" fullWidth>
                                                    <Autocomplete
                                                        label={"Specjalizacje"}
                                                        field={'specialties'}
                                                        source={Source.DICTIONARIES}
                                                        value={values.specialties}
                                                        error={Boolean(errors.specialties && touched.specialties)}
                                                        multiple={true}
                                                        setFieldValue={setFieldValue}
                                                        requestOptions={{type: Dictionaries.Specialty}}
                                                        helperText={errors.specialties as string}
                                                    />
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <FormControl margin="dense" fullWidth>
                                                    <Autocomplete
                                                        label={"Kwalifikacje"}
                                                        field={'qualifications'}
                                                        source={Source.DICTIONARIES}
                                                        value={values.qualifications}
                                                        error={false}
                                                        multiple={true}
                                                        setFieldValue={setFieldValue}
                                                        requestOptions={{type: Dictionaries.Qualification}}
                                                    />
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <FormControlLabel
                                                    control={<Checkbox id="active" checked={values.active}
                                                                       onChange={handleChange}
                                                                       color="primary"/>}
                                                    label="Aktywny"
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={() => handleSubmit()}
                                                    disabled={this.props.isProcessing}
                                                >
                                                    Zapisz
                                                </Button>
                                            </Grid>
                                        </Grid>

                                    </CardContent>
                                </Card>
                            </form>
                        )}
                    </Formik>
            }
        </>
}

const mapStateToProps: MapStateToProps<StateToProps, {}, State> = state => ({
    isLoading: isLoading(state),
    isProcessing: isProcessing(state),
})

export const Form = connect(mapStateToProps)(FormComponent)